import Button from "common/components/Button/Button";

import { Link } from "react-router-dom";
import useAuth from "common/hooks/useAuth";
import { useTranslation } from "react-i18next";

import Status from "common/components/Status/Status";
import { AccessRequest } from "types/AccessRequest";

function AccessRequestItem({ item, onDelete, onNavigate }: any) {
  const { user: currentUser } = useAuth();
  const canEditItem = currentUser?.isSuperadmin;

  const { user, quality, state } = item as AccessRequest;

  const editLink = item?.contact?.id ? `/contacts/edit/${item.contact.id}` : "";

  const { t } = useTranslation();

  return (
    <div className="flex px-4 py-4 mt-2 w-full relative bg-white cursor-pointer rounded-lg border border-slate-150 transition-all">
      <Link
        to={editLink}
        className={
          !canEditItem ? "pointer-events-none flex flex-1" : "flex flex-1"
        }
      >
        <div className="flex flex-col flex-1 justify-between pr-6 mb-2">
          <div className="flex flex-col sm:flex-row items-start sm:items-center md:gap-2 w-full">
            <h4 className="text-xl font-bold text-primary leading-4 mb-2 w-full">
              {user?.name}
            </h4>
            {item?.contact && item?.state === "accepted" && (
              <div className="shrink-0 bg-white text-secondary-700 text-md font-medium me-2 px-2 py-0.5 rounded dark:bg-secondary-700 dark:text-white">
                {item?.contact?.name}
              </div>
            )}
          </div>
          <p>{user?.email}</p>
          <p>{quality}</p>
        </div>
      </Link>

      <div className="flex flex-col justify-between items-end text-xs lg:border-l lg:pl-4 lg:min-w-[22em] border-slate-150 gap-2">
        <Status
          status={
            state === "accepted"
              ? "validated"
              : state === "pending"
              ? "waiting"
              : state
          }
          small
        />
        <div className="flex w-full items-center justify-end text-slate-500">
          <div>
            <div className="flex w-full gap-1">
              {item.state === "pending" && (
                <Button
                  type="error"
                  icon="XMarkIcon"
                  title={t("common.reject")}
                  compact
                  onClick={() => onDelete(item.id)} // we use the onDelete function to update to refused
                  disabled={!canEditItem}
                />
              )}

              {item.state !== "accepted" && (
                <Button
                  title={t("common.validate")}
                  type={item.state === "pending" ? "valid" : "valid-line"}
                  icon="CheckIcon"
                  onClick={() => onNavigate(item.id)}
                  disabled={!canEditItem}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessRequestItem;
